import reducers from '../reducers';
import { genericStoreSetup } from 'reactifi';

export default props => {
  return genericStoreSetup(reducers, props);
}